export default {
  black: '#2b2b2b',
  white: '#eee',

  error: '#ff4d4f', // red
  errorFade: '#ffb3b4',
  success: '#32d296', // green
  successFade: '#d9f7ec',
  warning: '#ffcf33', // yellow
  warningFade: '#fff3cd',

  grey100: '#f8f9fa',
  grey200: '#e9ecef',
  grey300: '#dee2e6',
  grey400: '#ced4da',
  grey500: '#adb5bd',
  grey600: '#6c757d',
  grey700: '#495057',
  grey800: '#343a40',
  grey900: '#212529',

  fontSizeHeader: '1.5rem',
  fontSizeLarge: '1.25rem',
  fontSizeBase: '1rem',
  fontSizeSmall: '0.875rem',
  fontSizeExtraSmall: '0.75rem',

  fontHeader: 'Montserrat',
  fontBody: 'Lato',
};
